/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.8.0",
  "gitBuildTime": "2026-10-20T14:08:16.165Z",
  "gitBuildVersion": "1.8.0",
  "gitCommitId": "ff2d9a7",
  "gitCommitIdFull": "ff2d9a760a48e6eb8e5459b366f68107389cced4",
  "gitCommitTime": "2026-10-20T14:06:12.000Z",
  "version": "1.8.0-2026-10-20T14:06:12.000Z-(ff2d9a7)"
};
